(function () {
  if (window.__rvkSectionsLoaded) return;
  window.__rvkSectionsLoaded = true;

  // Smooth scroll to the top of the page. Driven frame by frame towards 0 so it always
  // arrives, even if lazy-loaded content shifts the layout while scrolling.
  function scrollToTop() {
    var start = window.scrollY;
    var duration = Math.min(1200, 400 + start / 10);
    var startTime = null;
    var done = false;
    function step(time) {
      if (done) return;
      if (startTime === null) startTime = time;
      var progress = Math.min(1, (time - startTime) / duration);
      var eased = 1 - Math.pow(1 - progress, 3);
      window.scrollTo(0, Math.round(start * (1 - eased)));
      if (progress < 1) requestAnimationFrame(step);
      else done = true;
    }
    requestAnimationFrame(step);
    // Fallback when animation frames are throttled: jump to the top.
    setTimeout(function () {
      if (!done) {
        done = true;
        window.scrollTo(0, 0);
      }
    }, duration + 300);
  }

  // Buttons marked data-rvk-buy scroll back to the top of the product page (buy box).
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-rvk-buy]');
    if (!link) return;
    if (!document.querySelector('product-info')) return;
    event.preventDefault();
    scrollToTop();
  });

  // Horizontal carousel with arrows and inline video playback.
  if (!customElements.get('rvk-carousel')) {
    customElements.define(
      'rvk-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          if (!this.track) return;

          this.arrows = this.querySelectorAll('[data-dir]');
          this.arrows.forEach((button) => {
            button.addEventListener('click', () => {
              var card = this.track.firstElementChild;
              var gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
              var step = card ? card.getBoundingClientRect().width + gap : 300;
              this.track.scrollBy({ left: step * Number(button.dataset.dir), behavior: 'smooth' });
            });
          });

          // Grey out an arrow when there is nothing more to scroll in its direction.
          var updateArrows = () => {
            var max = this.track.scrollWidth - this.track.clientWidth - 2;
            this.arrows.forEach((button) => {
              var atEdge = Number(button.dataset.dir) < 0 ? this.track.scrollLeft <= 2 : this.track.scrollLeft >= max;
              button.disabled = atEdge;
            });
          };
          this.track.addEventListener('scroll', updateArrows, { passive: true });
          window.addEventListener('resize', updateArrows);
          updateArrows();

          this.querySelectorAll('[data-play]').forEach((button) => {
            button.addEventListener('click', () => {
              var card = button.closest('[data-card]');
              var video = card && card.querySelector('video');
              if (!video) return;
              this.querySelectorAll('video').forEach((other) => {
                if (other !== video) other.pause();
              });
              card.classList.add('is-playing');
              video.controls = true;
              video.play();
            });
          });
        }
      }
    );
  }
})();
